import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Layout from '../App/layout'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import ContentLayout from '../../components/utility/layoutContent'
import OrderReviewsIndexContainer from './OrderReviewsIndexContainer'

class OrderReviewIndexPage extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired
    }

    componentDidMount() {
        document.title = 'Order Reviews | OSH CRM'
    }

    render () {
        return (
            <Layout>
                <LayoutContentWrapper breadcrumbs={[
                    { path: '/order_reviews', name: 'Order Reviews' }
                ]}>
                    <ContentLayout>
                        <OrderReviewsIndexContainer />
                    </ContentLayout>
                </LayoutContentWrapper>
            </Layout>
        )
    }
}

export default OrderReviewIndexPage
